import React, { useEffect, useRef } from "react";
import FormTextField from "../../../components/textField/formTextField";
import FormCheckboxGroup from "../../../components/formCheckboxGroup";
import { engineerReportTypeService } from "../../../constants/enums";
import "./styles.css";

const ServiceTypeSection = ({
  control,
  setValue,
  errors,
  getValues,
  watch,
  engineeringReport,
  isComplete,
  isNew = false
}) => {
  const selectedValue = watch("services", []);

  const alreadyLoaded = useRef(false);

  useEffect(() => {
    if (engineeringReport && !alreadyLoaded.current) {

      if (isNew === true) return;

      const currentServices = getValues("services") || [];
      const currentOtherOp = getValues("otherOp");

      const serviceMappings = {
        is_corrective_maintenance:
          engineerReportTypeService.CorrectiveMaintenance,
        is_consumable_adjustments:
          engineerReportTypeService.ConsumablesAdjustment,
        is_academic_activity: engineerReportTypeService.AcademicActivity,
        is_preinstallation: engineerReportTypeService.PreInstallation,
        is_preventive_maintenance:
          engineerReportTypeService.PreventiveMaintenance,
        is_installation: engineerReportTypeService.Installation,
        is_software_update: engineerReportTypeService.SoftwareUpdate,
        is_training: engineerReportTypeService.Training,
        is_other: engineerReportTypeService.Other
      };

      if (currentServices.length === 0) {
        const selectedServices = Object.entries(serviceMappings)
          .filter(([key]) => engineeringReport[key])
          .map(([, value]) => value);

        setValue("services", selectedServices);
      }

      if (
        (!currentOtherOp || currentOtherOp === "") &&
        engineeringReport.is_other &&
        engineeringReport.is_other_value
      ) {
        setValue("otherOp", engineeringReport.is_other_value);
      }

      alreadyLoaded.current = true;
    }
  }, [engineeringReport, getValues, setValue]);

  const options = [
    {
      label: "Mantenimiento correctivo",
      value: engineerReportTypeService.CorrectiveMaintenance
    },
    {
      label: "Ajustes de consumibles",
      value: engineerReportTypeService.ConsumablesAdjustment
    },
    {
      label: "Actividad Académica",
      value: engineerReportTypeService.AcademicActivity
    },
    {
      label: "Preinstalación",
      value: engineerReportTypeService.PreInstallation
    },
    {
      label: "Mantenimiento preventivo",
      value: engineerReportTypeService.PreventiveMaintenance
    },
    { label: "Instalación", value: engineerReportTypeService.Installation },
    {
      label: "Actualización de Software",
      value: engineerReportTypeService.SoftwareUpdate
    },
    { label: "Capacitación", value: engineerReportTypeService.Training },
    { label: "Otro", value: engineerReportTypeService.Other }
  ];

  return (
    <div className="flex flex-wrap gap-4">
      <FormCheckboxGroup
        name="services"
        control={control}
        label=""
        options={options}
        disabled={isComplete}
      />
      {selectedValue.includes(engineerReportTypeService.Other) && (
        <div className="otherOp">
          <FormTextField
            name="otherOp"
            control={control}
            label=""
            error={errors.phone}
            margin={"0"}
            disabled={isComplete}
          />
        </div>
      )}
    </div>
  );
};

export default ServiceTypeSection;
